import { render, staticRenderFns } from "./Naw4.vue?vue&type=template&id=349d3064&scoped=true&"
import script from "./Naw4.vue?vue&type=script&lang=js&"
export * from "./Naw4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349d3064",
  null
  
)

export default component.exports